import { FC, useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { ThemeSelectorContext } from "@/context";


export const DynamicFavicon: FC = () => {
  const location = useLocation();
  const { clientDisplayName, favicon } = useContext(ThemeSelectorContext);

  useEffect(() => {
    updateFavicon();
    updateTitle();
  }, [location]);

  const updateFavicon = () => {
    const faviconElement = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (faviconElement) {
      const faviconPath = getFaviconPath();
      if (faviconPath) {
        faviconElement.href = faviconPath;
      }
    }
  };

  const updateTitle = () => {
    const title = getTitle();
    document.title = title;
  };

  const getFaviconPath = () => {
    return favicon?.url;
  };

  const getTitle = () => {
    return `Health Care Portal | ${clientDisplayName}`;
  };

  return null;
};

export default DynamicFavicon;
